import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeographiesService {
	constructor(private apiService: ApiService) { }

	getCountries() {
		const countryURL = environment.geographyServiceUrl + '/api/geographyService/v1/countries';
		return this.apiService.get(countryURL);
	}

	getStates(countryId = 91) {
		const statesURL =
			environment.geographyServiceUrl + '/api/geographyService/v1/states';
		return this.apiService.get(statesURL, {
			countryId,
			cache: true,
		});
	}
	getDistricts(stateId: number) {
		const districtsURL =
			environment.geographyServiceUrl +
			'/api/geographyService/v1/state/districts';
		return this.apiService.get(districtsURL, {
			stateId,
			cache: true,
		});
	}
	getTehsil(districtId: number) {
		const subDistrictsURL =
			environment.geographyServiceUrl +
			'/api/geographyService/v1/district/subDistricts';
		return this.apiService.get(subDistrictsURL, {
			districtId,
			cache: true,
		});
	}

	// filtered
	getStatess() {
		return this.getStates().pipe(map(res => {
			if (res) {
				return res.states.map(state => ({
					name: state.name,
					// value: state
				}));
			}
		}));
	}
	getDistrictss(code) {
		return this.getDistricts(code).pipe(map(res => {
			return res.districts.map(district => ({
				name: district.name,
				value: district
			}));
		}));
	}

	getParliamentaryConstituenciess(stateCode) {
		const getParliamentaryConstituenciesApi: string =
			environment.geographyServiceUrl +
			'/api/geographyService/v1/state/parliamentaryConstituency?stateId=' +
			stateCode;
		return this.apiService
			.get(getParliamentaryConstituenciesApi, {
				cache: true,
			})
			.pipe(map(res => res));
		// const getParliamentaryConstituenciesApi: string = environment.commonServiceApiUrl + '/geography/districts?state=' + stateName;
		// return this.apiService.get(getParliamentaryConstituenciesApi)
		// 	.map(res => res);
	}

	// To get tehsils of selected district
	getTehsilss(districtCode) {
		return this.getTehsil(districtCode).pipe(map(tehsils => {
			return tehsils.subDistricts.map(tehsil => ({
				name: tehsil.name,
				value: tehsil,
			}));
		}));
	}
	getVillages(subDistrictId) {
		const villageAPI = `${environment.geographyServiceUrl}/api/geographyService/v1/subDistrict/villages?subDistrictId=${subDistrictId}`;
		return this.apiService.get(villageAPI, {
			cache: true,
		});
	}

	checkStateIsNE(stateId) {
		const url = `${environment.userServiceUrl}/api/user/v1/check/state/ne?stateId=${stateId}`;
		return this.apiService.get(url);
	}

	getNorthEastStatesOnly() {
		const url = `${environment.userServiceUrl}/api/user/v1/state/ne`;
		return this.apiService.get(url);
	}

	getBlockList(districtCode) {
		const url = `${environment.userServiceUrl}/api/user/v1/districts/blocks?districtCode=${districtCode}`;
		return this.apiService.get(url);
	}
	getGramPanchayatList(blockCode) {
		const url = `${environment.userServiceUrl}/api/user/v1/districts/gp?blockCode=${blockCode}`;
		return this.apiService.get(url);
	}

	getVillageAndLocalBodies(subDistrictId, villageId?) {
		const query = {
			subDistrictId: subDistrictId,
			villageId: villageId || ''
		}
		let url = `${environment.geographyServiceUrl}/api/geographyService/v1/subDistrict/gramPanchayat`;
		// if (villageId) {
		// 	url = url.concat('&villageId=', villageId)
		// }
		return this.apiService.get(url, query);
	}
}
